<template>
  <div class="p-[20px] border border-solid border-steam rounded-[8px]">
    <div class="flex gap-[4px]">
      <shipblu-icon iconLibrary="feather" iconName="PackageIcon" iconClass="text-industrial-revolution text-[18px]"/>
      <p class="text-lg text-young-night">
        {{ $t('Product Details') }}
        <span class="text-sm">({{ $t('including tax if applicable') }})</span>
      </p>
    </div>
    <div v-if="(orderData.status === 'delivered' && orderData.buy_and_try_product_in_order && orderData.buy_and_try_product_in_order.length > 0 && orderData.buy_and_try_product_in_order.filter(item => item.requested_quantity !== item.delivered_quantity).length > 0) || (orderData.return_items && orderData.return_items.length > 0)">
      <p class="text-base text-darkgray font-medium leading-tight">
        ({{ common.defineOrderType(orderData) === 'delivery-orders' ? $t('Try and Buy Return Order') : $t('Try and Buy Delivery Order') }}
        <router-link :to="openLinkedOrder()">
          <span class="text-primary underline font-semibold cursor-pointer">{{ common.defineOrderType(orderData) === 'delivery-orders' ? '2' + orderData.tracking_number + 'TB' : orderData.tracking_number.slice(1).split('TB')[0] }}</span>
        </router-link>)
      </p>
    </div>
    <div class="mt-6">
      <div v-for="(item, index) in orderData.return_items ? orderData.return_items : orderData.buy_and_try_product_in_order" :key="index">
        <div class="flex gap-4 lg:items-center items-end mb-4">
          <img v-if="item.product_image_url" :src="item.product_image_url" alt="product image" class="lg:w-[64px] lg:h-[64px] w-[78px] h-[78px] flex-shrink-0 object-contain rounded-md"/>
          <div v-else class="lg:w-[64px] lg:h-[64px] w-[78px] h-[78px] flex-shrink-0 bg-steam flex items-center justify-center rounded-md">
            <shipblu-icon iconLibrary="feather" iconName="ImageIcon" iconClass="text-white text-[24px]"/>
          </div>
          <div class="grid lg:grid-cols-2">
            <p class="text-young-night font-medium lg:col-span-2 mb-1">{{ item.product_name }}</p>
            <p class="text-young-night leading-[20px]">{{ $t('SKU') }}: 
              <span class="text-industrial-revolution">{{ item.product_sku }}</span>
            </p>
            <p class="text-young-night leading-[20px]">{{ $t('Unit Price') }}:
              <span class="text-industrial-revolution">{{ $t('EGP') }} {{ Number(item.unit_price).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</span>
            </p>
            <p class="text-young-night leading-[20px]">{{ $t('Shipped Qty') }}:
              <span class="text-industrial-revolution">{{ item.requested_quantity }}</span>
            </p>
            <p v-if="orderData.status === 'delivered'" class="text-young-night leading-[20px]">{{ $t('Delivered Qty') }}:
              <span class="text-industrial-revolution">{{ item.delivered_quantity }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/assets/utils/common'

export default {
  props: ['orderData'],
  data () {
    return {
      common
    }
  },
  methods: {
    openLinkedOrder () {
      if (this.$store.state.AppActiveUser.userRole === 'head-of-fleet') {
        if (common.defineOrderType(this.orderData) === 'delivery-orders') {
          return `/${this.$i18n.locale}/team-leader/search?search=${`2${  this.orderData.tracking_number  }TB`}`
        } else {
          return `/${this.$i18n.locale}/team-leader/search?search=${this.orderData.tracking_number.slice(1).split('TB')[0]}`
        }
      } else {
        return common.defineOrderType(this.orderData) === 'delivery-orders' ? `/${this.$i18n.locale}/${this.$store.state.AppActiveUser.userRole}/orders/returns?search=${`2${  this.orderData.tracking_number  }TB`}` : `/${this.$i18n.locale}/${this.$store.state.AppActiveUser.userRole}/orders/delivery-orders?search=${this.orderData.tracking_number.slice(1).split('TB')[0]}` 
      }
    }
  }
}
</script>